import { REDIRECT_WHITE_LIST } from '@/constants/common';

const LOCAL_NEW_UI_DISABLED_VALUES = new Set(['', '0', '1']);
const LOCAL_NEW_UI_PUBLIC_ROUTE_NAMES = new Set(['login', 'registration', 'forgetpassword']);
const LOCAL_NEW_UI_SKIP_ROUTE_NAMES = new Set(['authSSO', 'authresult', 'auth_result', 'noProject', 'error401', 'error404']);

interface RedirectToNextArgs {
    localIsNewUi: string;
    hasToken: boolean;
    isInIframe: boolean;
    isPublicRoute: boolean;
    routeName?: string;
}

/**
 * 从本地缓存的 `ss_new_ui` 字符串中解析出 `isNewUi` 值。
 *
 * 当前本地缓存格式为 `${isNewUi},${timestamp}`，路由提前判断只关心逗号前的开关值。
 *
 * @param localValue 从 localStorage 读取到的原始值。
 * @returns 解析后的 `isNewUi` 值；不存在时返回空字符串。
 */
export const getLocalIsNewUiValue = (localValue: string): string => {
    if (!localValue) {
        return '';
    }
    return localValue.split(',')[0] || '';
};

/**
 * 判断当前导航是否应该在旧版路由守卫阶段直接硬跳到 `/next`。
 *
 * 这里会统一处理本地 `isNewUi` 开关、iframe 场景，以及必须留在旧版的路由白名单。
 * 对公开页会再额外收窄到允许提前跳转的几个入口页，避免误伤授权回调等老页面。
 *
 * @param args 提前跳转 `/next` 所需的上下文信息。
 * @returns 命中提前跳转条件时返回 `true`。
 */
export const shouldRedirectToNextByLocalIsNewUi = ({
    localIsNewUi,
    hasToken,
    isInIframe,
    isPublicRoute,
    routeName,
}: RedirectToNextArgs): boolean => {
    if (!routeName || LOCAL_NEW_UI_DISABLED_VALUES.has(localIsNewUi) || isInIframe) {
        return false;
    }
    if (LOCAL_NEW_UI_SKIP_ROUTE_NAMES.has(routeName) || REDIRECT_WHITE_LIST.includes(routeName)) {
        return false;
    }
    if (isPublicRoute) {
        return LOCAL_NEW_UI_PUBLIC_ROUTE_NAMES.has(routeName);
    }
    return hasToken;
};
